<template>
	<div class="container-fluid content">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ $t('Perfil de usuario') }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <usuario-editar-perfil></usuario-editar-perfil>
      </div>
      <div class="col-md-4">
        <usuario-cambiar-contrasena></usuario-cambiar-contrasena>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Perfil de usuario": "Perfil de usuario"
  },
  "en": {
   
  },
  "ca": {
    "Perfil de usuario": "Perfil d'usuari"
  }
}
</i18n>

<script>
  import UsuarioEditarPerfil from './UsuarioEditarPerfil.vue';
  import UsuarioCambiarContrasena from './UsuarioCambiarContrasena.vue';

	export default {
    components: { UsuarioEditarPerfil, UsuarioCambiarContrasena},
    data: () => {
      return {
        showModalFichaExtendida: false,
      }
    },
    mounted(){
      //this.cargarResultadoBusqueda(this.getLocale);
    },
    computed:{
    },
    methods:{
     
    }
  }
</script>
